/**
 * The standing microphone the sing and microphone glyphs both draw: a
 * rounded capsule, the cradle arcing under its foot, and a stem down to a
 * short base. Drawn once, at the sing glyph's place left of center, so the
 * two never drift apart; the microphone glyph moves and scales it into the
 * middle of the box.
 */// The microphone's middle, left to right and top to bottom, where it is
// drawn.
export const MIC_CENTER_X=8;export const MIC_CENTER_Y=11.5;// The capsule's own middle, which a glyph pulsing the capsule swells from.
export const CAPSULE_CENTER_Y=8.5;export const CAPSULE="M5.5 5.5a2.5 2.5 0 0 1 5 0v6a2.5 2.5 0 0 1-5 0z";export const CRADLE="M3.5 10.5v1a4.5 4.5 0 0 0 9 0v-1";export const STAND="M".concat(MIC_CENTER_X," 16v4M5.5 20h5");